import { formatNumber } from '@shared/lib/utils/number';

export function getPrice(initialPrice: number | string = 0): string {
  const normalizedPrice = parsePrice(initialPrice);

  if (isNaN(normalizedPrice)) {
    return '0';
  }

  return formatNumber(normalizedPrice);
}

function parsePrice(price: number | string): number {
  return typeof price === 'string' ? parseFloat(price) : price;
}
